var map = {
	"./academic.png": "7eaa",
	"./career.png": "d900",
	"./cv.png": "75e7",
	"./information.png": "1bf2",
	"./landing/icon_cs_feature_assessment.png": "9236",
	"./landing/icon_cs_feature_elearning.png": "bb2e",
	"./landing/icon_cs_feature_event.png": "d432",
	"./landing/icon_cs_feature_jobfair.png": "6d21",
	"./landing/icon_cs_feature_jobs.png": "75f8",
	"./landing/icon_cs_feature_profile.png": "c78c",
	"./learning.png": "cda2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";